import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'
import type * as models from '../../models'
import * as fragments from '../fragments'

// NOTE: Multiple fragments are created for transformer purposes
export const DOC = gql`
  ${fragments.mosaicPageContent.DOC}
  ${common.gql.dms.data.fragments.variable.DOC}
  query MosaicPage($tenantId: ID!, $zoneId: ID!, $pageId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicPage(pageId: $pageId) {
          id
          alias
          name
          description
          hasQuery
          content {
            ...FragmentMosaicPageContent
          }
          variables {
            ...FragmentVariable
          }
        }
      }
    }
  }
`

// NOTE: we use `nonNull` because if we don't receive a mosaic page, then the query
// has effectively failed
const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.MosaicPageQuery,
    models.page.Page.ForRequest | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'mosaicPage',
        graphql.transformers.OUT.object({
          alias: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
          content: {
            // TODO avoid using custom transformer. Check with Sander how to solve this
            usingFullInput: graphql.transformers.OUT.custom(({ content }) => {
              TypeAsserter.assertIsNotNullish(content)
              const transformedContent =
                fragments.mosaicPageContent.TRANSFORMER.getEntityFrom(content)
              TypeAsserter.assertIsNotNullish(transformedContent)

              return transformedContent
            }),
          },
          description: transformers.PASS_THROUGH,
          hasQuery: graphql.transformers.OUT.default(
            transformers.PASS_THROUGH,
            false,
          ),
          id: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
          name: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
          variables: {
            usingFullInput: graphql.transformers.OUT.default(
              graphql.transformers.OUT.select(
                'variables',
                graphql.transformers.OUT.list(
                  common.gql.dms.data.fragments.variable.TRANSFORMER,
                  { onNullish: 'remove' },
                ),
              ),
              [],
            ),
          },
        }),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.MosaicPageQuery,
  models.page.Page.ForRequest,
  graphql.schema.MosaicPageQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
